"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromptCreatePayloadSchema = exports.PromptListSchema = exports.PromptObjectSchema = void 0;
const zod_1 = require("zod");
const index_1 = require("../list/index");
const index_2 = require("../workflow/index");
exports.PromptObjectSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    object: zod_1.z.literal('prompt'),
    text: zod_1.z.string(),
    data: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
    format: zod_1.z.object({}),
    created_at: zod_1.z.date().openapi({ format: 'date-time' }),
})
    .openapi('PromptObject');
exports.PromptListSchema = (0, index_1.ListResponseSchema)(exports.PromptObjectSchema, {
    title: 'PromptList',
});
exports.PromptCreatePayloadSchema = zod_1.z
    .discriminatedUnion('type', [
    zod_1.z
        .object({
        type: zod_1.z.literal('survey'),
        data: index_2.WorkflowSurveyInputSchema,
    })
        .openapi('PromptCreateSurveyPayload'),
    // z
    //     .object({
    //         type: z.literal('analysis'),
    //         data: WorkflowSurveyInputSchema,
    //     })
    //     .openapi('PromptCreateAnalysisPayload'),
])
    .openapi('PromptCreatePayload');
//# sourceMappingURL=promptSchema.js.map